import script from "./FakeInstantPaymentForm.vue?vue&type=script&lang=js"
export * from "./FakeInstantPaymentForm.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__